import rankingQuery from './index.vue';
import shopRankingQuery from './shopRankingQuery/shopRankingQuery';
import productionRankingQuery from './productionRankingQuery/productionRankingQuery';
import keywordsRankingQuery from './keywordsRankingQuery/keywordsRankingQuery';
import queryRecord from './queryRecord/queryRecord';

rankingQuery.childRoutes = [
    {
        path: 'shopRankingQuery',
        name: 'shopRankingQuery',
        component: shopRankingQuery,
    },
    {
        path: 'productionRankingQuery',
        name: 'productionRankingQuery',
        component: productionRankingQuery,
    },
    {
        path: 'keywordsRankingQuery',
        name: 'keywordsRankingQuery',
        component: keywordsRankingQuery,
    },
    {
        path: 'queryRecord',
        name: 'queryRecord',
        component: queryRecord,
    },
    {
        path: '/',
        redirect: 'shopRankingQuery',
    },
];

export default rankingQuery;
